import { ChangeDetectorRef, Component, ElementRef, forwardRef, Inject, QueryList, Renderer2, ViewChildren, ViewContainerRef } from '@angular/core';
import { infoPopUpComponent } from "sharedFeatures/infoPopUp";
import { NewPlanForm, NewPlanFormBodyComponent } from 'sharedFeatures/newplan-win';
import { ScrollComponent } from "sharedFeatures/scroll";
import { XeroService } from 'sharedFeatures/sharedServices';
import { DialogCreator } from "sharedFeatures/window";
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { DraggabledDirective, ListDropTargetDirective } from '../../../../directives';
import { MoveBtnComponent } from '../move-btn/move-btn.component';
import { Xi2ProfitLossBaseComponent } from './xi-2-profitloss-base.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xi-2-profitloss-form-body',
    templateUrl: './xi-2-profitloss-form-body.component.html',
    styleUrls: ['./xi-2-profitloss-form-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, MoveBtnComponent, DraggabledDirective, ListDropTargetDirective, infoPopUpComponent, TranslateModule]
})
export class Xi2ProfitLossFormBodyComponent extends Xi2ProfitLossBaseComponent {

    @ViewChildren(infoPopUpComponent)
    infoPopupItems: QueryList<infoPopUpComponent> | undefined = undefined;

    constructor(
        el: ElementRef,
        r: Renderer2,
        xeroService: XeroService,
        @Inject(forwardRef(() => NewPlanForm)) private injected: NewPlanForm,
        bodyViewRef: ViewContainerRef,
        chDet: ChangeDetectorRef
    ) {

        super(el, r, xeroService, bodyViewRef, chDet);

    }

    ngAfterViewInit() {

        super.ngAfterViewInit();

        this.injected.getOnClose().subscribe(this.onParentClose.bind(this));
    }

    closeOtherInfoPanels(id: string) {
        if(this.infoPopupItems)
            this.infoPopupItems.forEach(x => {
                if (x.pFieldID !== id) x.close();
            });
    }

    loadPLAccounts(): void {

        super.loadPLAccounts(() => { this.injected.close(); }, () => { this.injected.enableContinue(); })

    }

    reloadPLAccounts(): void {

        super.loadPLAccounts();

    }

    protected onParentClose(): void {

        super.onParentClose();
        this.r.setStyle(this.saveClosePanePlaceEl(), 'height', '0px');

    }

    public getScrollPane(): ScrollComponent {

        return (<NewPlanFormBodyComponent>this.injected.getBodyComponent()).getScrollPane();

    }

    onClose() {

        this.injected.showSetupWarning();

    }

    public saveClosePanePlaceEl(): Element {

        return this.injected.getBodyComponent().saveClosePanePlaceEl();

    }

    public getDialogCreator(): DialogCreator {

        return this.injected.getDialogCreator();

    }

}